import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../../../component/common/CustomPagination";
import { koKRGrid } from "../../../../component/common/TableKRText";
import SwWorkerAsgDialog from "./SwWorkerAsgDialog"
import api from "../../../../../API";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../../component/common/SearchBackDrop";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function CustomToolbar(props: any) {

  // console.log('CustomToolbar props :::: ' , props)

  return (
    <GridToolbarContainer>
      {/* <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
       <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      /> */}
      <Box sx={{width:"100%", display:"flex", justifyContent:"center"}}>
      {props.user_cnt.total_cnt > 0 &&
        <Box display="flex" sx={{alignItems: "center", borderRadius:"12px", padding:"2px"}}>
          <Box sx={{backgroundColor:"#38c73d",fontWeight:600,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px",marginRight:"32px", color:"#fff"}}>할당가능  : <b style={{color:"#fff"}}>{props.user_cnt.asg_ready_cnt}</b> 건</Box>
          <Box display="flex" sx={{backgroundColor:"#9a8fff", alignItems: "center", borderRadius:"12px", padding:"2px"}}>
            <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px",marginRight:"32px", color:"#000"}}>전체  : <b style={{color:"red"}}>{props.user_cnt.total_cnt}</b> 건</Box>
            <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#000"}}>할당  : <b style={{color:"red"}}>{props.user_cnt.w_cnt}</b> 건</Box>
            <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#9e9e9e"}}>잔여  : <b style={{color:"red"}}>{props.user_cnt.r_cnt}</b> 건</Box>
            <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", marginRight:"32px", color:"#2f439c"}}>완료  : <b style={{color:"red"}}>{props.user_cnt.o_cnt}</b> 건</Box>
          </Box>
          <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#2f9c34"}}>적합  : <b style={{color:"red"}}>{props.user_cnt.y_cnt}</b> 건</Box>
          <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#d37049"}}>부적합  : <b style={{color:"red"}}>{props.user_cnt.n_cnt}</b> 건</Box>
        </Box>
      }
      </Box>

      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>

        {/* <Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#2f9c34"}}>총 건수 :{props.totalCount ? props.totalCount : "0"} 건</Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#000"}}>선택 :{props.selectCheckCnt ? props.selectCheckCnt : "0"} 개</Box>
        </Box> */}

        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>정렬</Box>
        <Select id="order" value={props.order} onChange={(e)=>props.setOrder(e.target.value)} sx={{width:"100px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"asc"}>처음</MenuItem>
          <MenuItem dense value={"desc"}>최신</MenuItem>
        </Select> */}

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>주제분류</Box>
        <Select id="topic_cd" value={props.topic_cd} onChange={(e)=>props.setTopic_cd(e.target.value)} sx={{width:"164px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
          <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
          <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
          <MenuItem dense value={"204"}>사회,산업</MenuItem>
          <MenuItem dense value={"205"}>정치,경제</MenuItem>
          <MenuItem dense value={"206"}>과학,의학</MenuItem>
          <MenuItem dense value={"307"}>관습,의례</MenuItem>
          <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>Instruction 체크</Box>
        <Select id="instruction_yn" value={props.instruction_yn} onChange={(e)=>props.setInstruction_yn(e.target.value)} sx={{width:"124px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>사용가능</MenuItem>
          <MenuItem dense value={"None"}>미분류</MenuItem>
        </Select>

        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>검수결과</Box>
        <Select id="isp_yn" value={props.isp_yn} onChange={(e)=>props.setIsp_yn(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>적합</MenuItem>
          <MenuItem dense value={"N"}>부적합</MenuItem>
          <MenuItem dense value={"0"}>미분류</MenuItem>
          <MenuItem dense value={"YN"}>작업완료(적합+부적합)</MenuItem>
        </Select> */}
        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>소음파일</Box>
        <Select id="vn_yn" value={props.vn_yn} onChange={(e)=>props.setVn_yn(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>있음</MenuItem>
          <MenuItem dense value={"N"}>없음</MenuItem>
        </Select> */}

        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>IDX</Box>
        <TextField size="small" id="col_pk" value={props.col_pk} onChange={(e)=>props.setCol_pk(e.target.value)} sx={{width:"100px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} /> */}

        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>워커</Box>
        <Select id="order" value={props.worker} onChange={(e)=>props.setWorker(e.target.value)} sx={{width:"230px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          {props.swWorkers.length > 0 && props.swWorkers.map((worker:any) => 
            <MenuItem dense value={worker.user_id}>{worker.name}({worker.user_id})</MenuItem>
          )}
        </Select> */}

        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>워커ID</Box>
        <TextField size="small" id="worker" value={props.worker} onChange={(e)=>props.setWorker(e.target.value)} sx={{width:"90px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} /> */}
        <Button variant="contained" sx={{marginLeft:"8px"}} onClick={()=>{props.setWorkerParam(); props.setColPkParam();}}>검색</Button>
        {/* {props.adminRole && <Button variant="contained" sx={{marginLeft:"4px",backgroundColor:"#2f9c34"}} onClick={()=>{props.csqaListDown(); }}>엑셀</Button>} */}
      </Box>
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>시작일(검수)</Box>
          <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="isp1_date_start" name="isp1_date_start" size="small" type="date"
                    value={props.isp_s_date} onChange={(e)=>props.setIsp_s_date(e.target.value)}
          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
            InputProps={{
              style: {width: "150px", height:"30px", fontSize:"14px"},
              inputProps: { 
                spellCheck: "false" // spellcheck를 false로 설정
              },
            }}
          />

          <Box sx={{marginLeft:"8px", color:"#1976d2"}}>종료일(검수)</Box>
          <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="isp1_date_end" name="isp1_date_end" size="small" type="date"
                    value={props.isp_e_date} onChange={(e)=>props.setIsp_e_date(e.target.value)}
          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
            InputProps={{
              style: {width: "150px", height:"30px", fontSize:"14px"},
              inputProps: { 
                spellCheck: "false" // spellcheck를 false로 설정
              },
            }}
          />
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
}

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

const SwWorkerStatus = () => {

  const [page, setPage] = useState(1);

  const [totalCount, setTotalCount] = useState(0);
  const [selectCheckCnt , setSelectCheckCnt] = useState(0)

  const handleSelectionModelChange = (ids:any) => {
    setSelectCheckCnt(ids.length)
  };

  const [isp_yn, setIsp_yn] = useState('모두');
  const [instruction_yn, setInstruction_yn] = useState('모두');
  const [worker, setWorker] = useState('모두');
  const [col_pk, setCol_pk] = useState('');
  const [order, setOrder] = useState('desc');

  const [topic_cd, setTopic_cd] = useState('모두');

  const [p_worker, setP_worker] = useState('');
  const [p_col_pk, setP_col_pk] = useState('');

  const [isp_s_date, setIsp_s_date] = useState('');
  const [isp_e_date, setIsp_e_date] = useState('');

  const [p_isp_s_date, setP_isp_s_date] = useState('');
  const [p_isp_e_date, setP_isp_e_date] = useState('');

  const [user_id, setUser_id] = useState('모두');
  const [swWorkers, setSwWorkers] = useState<any[]>([])

  const [user_cnt, setUser_cnt] = useState<any>([])

  const [dclickUser, setDclickUser] = useState("")

  const setWorkerParam = () => {
    setP_worker(worker);
    setP_isp_s_date(isp_s_date);
    setP_isp_e_date(isp_e_date);
  }

  const setColPkParam = () => {
    setP_col_pk(col_pk);
  }

  const [rows, setRows] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;


  let adminRole = auth.user.roles.some((obj:any) => ['ADMIN'].includes(obj.role));

  const getSwIspWorkerList = async () => {
    setBackdrop(true)
    var result = await api.get("/gncWorkerList", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,role:'TZA_ISP'}
    });
    // console.log("result.data", result.data);
    let swWorkList:any[] = []
    var datas = result.data.datas.map((worker:any) => {
      // // console.log(worker.name, worker.roles[0].user_id)
      swWorkList.push({"name":worker.name,"user_id": worker.roles[0].user_id})
    })

    // console.log('swWorkList',swWorkList)
    setSwWorkers(swWorkList)
    setBackdrop(false)
  }

  const getWorkerInfo = async (user_id:string,p_isp_s_date:string,p_isp_e_date:string) => {
    // console.log(user_id,'정보가져오기')
    var result = await api.get("/swIspWorker-info", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,isp1_user:user_id,p_isp_s_date:p_isp_s_date,p_isp_e_date:p_isp_e_date}
    });
    // console.log("user_cnt ??? ", result.data.datas);

    setUser_cnt(result.data.datas[0])
    
  }
  
  const getSwList = async (order:string,isp_yn:string,instruction_yn:string,worker:string,topic_cd:string) => {
    setBackdrop(true)
    var result = await api.get("/swWorkerStatus", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,order:order,page:page,isp_yn:(isp_yn ? isp_yn: "모두"),instruction_yn:(instruction_yn ? instruction_yn: "모두"),worker:(worker != "모두" ? worker: ""),col_pk:(p_col_pk ? p_col_pk: ""),p_isp_s_date:p_isp_s_date,p_isp_e_date:p_isp_e_date,topic_cd:topic_cd}
    });
    // console.log("작업자 현황", result.data);
    setBackdrop(false)
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        user_id : data.user_id,
        total_cnt : data.total_cnt,
        o_cnt : data.o_cnt,
        r_cnt : data.r_cnt,
        y_cnt : data.y_cnt,
        n_cnt : data.n_cnt,
      };
    });

    // console.log('sample list')

    // table에 넣을 rows 데이터 state에 저장
    setRows(datas);
    // // pagination에 넣을 api data 페이지 정보를 state에 저장
    // setPagination(result.data.pagination);
    // // console.log('result.data.pagination.total_count',result.data.pagination)
    // setTotalCount(result.data.pagination.total_count);

    
    getWorkerInfo("",p_isp_s_date,p_isp_e_date)

  };

  useEffect(() => {
    getSwIspWorkerList();
    getSwList(order,isp_yn,instruction_yn,p_worker,topic_cd);
  }, [instruction_yn,isp_yn,page,order,p_worker,p_col_pk,p_isp_s_date,p_isp_e_date,topic_cd]);

  const [dialogOpen, setDialogOpen] = useState(false);

  const goDetail = (data: any) => {
    // console.log("더블클릭", data.user_id, user_cnt.asg_ready_cnt);
    setDclickUser(data)
    

    // setRowDetail(data);
    setDialogOpen(true);
  };

  const updateAfter = () => {
    setDclickUser("")
    getSwIspWorkerList();
    getSwList(order,isp_yn,instruction_yn,p_worker,topic_cd);
  }

  const columns: GridColDef[] = [
    // { field: "idx", headerName: "idx", headerAlign: "center", width: 84,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>idx</Box>
    //   )
    // },
    {
      field: "user_id", headerName: "검수자", headerAlign: "center", headerClassName: "header-style", width: 230,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검수자</Box>
      ),
      // renderCell: (params:any) => (
      //   <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value.replace('None','-')}</Box>
      // ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"14px", cursor:"pointer", display:"flex", justifyContent:"center", width:"100%"}}>
          {swWorkers.map((worker:any) => {
            if(worker.user_id == params.value){
              return (worker.name + " (" + worker.user_id + ")")
            }
          })}
        </Box>
      ),
    },
    { field: "total_cnt", headerName: "할당건수", headerAlign: "center", width: 160, type:"number",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>할당건수</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:700, fontSize:"14px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "o_cnt", headerName: "완료건수", headerAlign: "center", width: 160, type:"number",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>완료건수</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"14px", cursor:"pointer", color:"#002ba3"}}>{params.value}</Box>
      ),
    },
    { field: "r_cnt", headerName: "미작업건수", headerAlign: "center", width: 160, type:"number",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>미작업건수</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"14px", cursor:"pointer", color:"red"}}>{params.value}</Box>
      ),
    },
    { field: "y_cnt", headerName: "적합건수", headerAlign: "center", width: 160, type:"number",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>적합건수</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"14px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "n_cnt", headerName: "부적합건수", headerAlign: "center", width: 160, type:"number",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>부적합건수</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"14px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    
  ];

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"},
        ".MuiDataGrid-cellContent": {fontSize : "12px", cursor:"pointer"},
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>TZA. 스와힐리어(SW) - 작업자현황</h3></Box>
        <Box sx={{ height: "800px", width: "100%",position:"relative" }}>
          {backdrop && ( <SearchBackDrop/> )}
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            rowHeight={38}
            components={{ Toolbar: CustomToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },

                totalCount:totalCount,
                selectCheckCnt: selectCheckCnt,

                isp_yn: isp_yn,
                setIsp_yn: setIsp_yn,

                isp_s_date: isp_s_date,
                setIsp_s_date: setIsp_s_date,
                isp_e_date: isp_e_date,
                setIsp_e_date: setIsp_e_date,

                instruction_yn: instruction_yn,
                setInstruction_yn: setInstruction_yn,

                order: order,
                setOrder: setOrder,

                worker: worker,
                setWorker: setWorker,
                setWorkerParam: setWorkerParam,

                col_pk: col_pk,
                setCol_pk: setCol_pk,
                setColPkParam: setColPkParam,

                adminRole: adminRole,

                swWorkers: swWorkers,

                user_cnt: user_cnt,

                topic_cd: topic_cd,
                setTopic_cd: setTopic_cd,

              },
            }}
            getRowId={(row) => row.user_id}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            onFilterModelChange={(e) => console.log('이벤트!!!',e)}
            // sx={{cursor:"pointer"}}
          />
        </Box>
      </ThemeProvider>
      {dialogOpen == true && user_cnt.asg_ready_cnt > 0 ? (
        <SwWorkerAsgDialog
          dclickUser={dclickUser}
          setDialogOpen={setDialogOpen}
          asg_ready_cnt={user_cnt.asg_ready_cnt}
          updateAfter={updateAfter}
        />
      ) : ""}
    </Box>
  );
};
export default SwWorkerStatus;
